import { FormEvent, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { identityApi, type IdentityRecord } from '../../api/identity';

export function IdentityDetailsPage() {
  const { id = '' } = useParams();
  const [identity, setIdentity] = useState<IdentityRecord | null>(null);
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState('');

  async function load() {
    setError('');
    try {
      const data = await identityApi.get(id);
      setIdentity(data);
      setDisplayName(data.display_name);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load identity');
    }
  }

  useEffect(() => {
    if (id) void load();
  }, [id]);

  async function onSave(e: FormEvent) {
    e.preventDefault();
    try {
      const updated = await identityApi.patch(id, { display_name: displayName });
      setIdentity(updated);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Update failed');
    }
  }

  if (!identity && !error) {
    return <p className="p-6 text-slate-600">Loading…</p>;
  }

  return (
    <div className="mx-auto max-w-3xl p-6">
      <Link to="/identity" className="text-sm text-slate-600 hover:underline">← Directory</Link>
      <h1 className="mt-4 text-2xl font-semibold text-slate-900">Identity Details</h1>
      {error && <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}
      {identity && (
        <>
          <dl className="mt-6 grid gap-3 rounded-xl border border-slate-200 bg-white p-4 text-sm">
            <div><dt className="text-slate-500">ID</dt><dd className="font-mono text-slate-900">{identity.id}</dd></div>
            <div><dt className="text-slate-500">Email</dt><dd>{identity.email}</dd></div>
            <div><dt className="text-slate-500">Status</dt><dd>{identity.status}</dd></div>
            <div><dt className="text-slate-500">Type</dt><dd>{identity.type}</dd></div>
          </dl>
          <div className="mt-4 flex flex-wrap gap-3 text-sm">
            <Link to={`/identity/${id}/profile`} className="text-slate-600 hover:underline">Profile</Link>
            <Link to={`/identity/${id}/preferences`} className="text-slate-600 hover:underline">Preferences</Link>
            <Link to={`/identity/${id}/activity`} className="text-slate-600 hover:underline">Activity</Link>
            <Link to={`/identity/${id}/audit`} className="text-slate-600 hover:underline">Audit</Link>
          </div>
          <form onSubmit={onSave} className="mt-6 space-y-3 rounded-xl border border-slate-200 bg-white p-4">
            <label className="block text-sm text-slate-600">Display name
              <input value={displayName} onChange={(e) => setDisplayName(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" />
            </label>
            <button type="submit" className="rounded-lg bg-slate-900 px-4 py-2 text-white">Save</button>
          </form>
        </>
      )}
    </div>
  );
}
